import React from "react"
import {Route, Redirect, withRouter, RouteComponentProps} from "react-router-dom"

export interface IndexRedirectProps extends RouteComponentProps {
  to: string
}

const IndexRedirect: React.FC<IndexRedirectProps> = ({match, to, location}) => {
  let url = "/"
  const query = location.search || ""

  if (match) {
    url = match.url
  }

  /** remove doubled up `/`'s between `url` and `to` */
  if (url.charAt(url.length - 1) === "/" && to.charAt(0) === "/") {
    url = url.slice(0, -1)
  }

  return <Route exact path={url} component={() => <Redirect to={{...location, pathname: `${url}${to}${query}`}} />} />
}

export default withRouter(IndexRedirect)
